import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-link.png'


const _withScopeId = n => (_pushScopeId("data-v-05c83882"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "link-view" }
const _hoisted_2 = { class: "link-menu" }
const _hoisted_3 = ["href", "target"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "link-icon",
  src: _imports_0
}, null, -1))

import { computed } from 'vue'
import { useInitDataStore } from '@/stores/initDataStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const initDataStore = useInitDataStore()
const links = computed(() => {
  return initDataStore.definitionInfoLink
})
const target = (direct: boolean) => {
  return direct ? '_blank' : '_self'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(links), (link, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "item"
        }, [
          _createElementVNode("a", {
            href: link.link,
            target: target(link.directLink)
          }, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(link.title), 1)
          ], 8, _hoisted_3)
        ]))
      }), 128))
    ])
  ]))
}
}

})